/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { color, pxToEm, imageTypes, animations } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// INSTICATOR LOGO STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	insticator: {
		display: 'inline-block',
		lineHeight: '0',
		textDecoration: 'none',
		'& .poweredby': {
			color: color.white,
			display: 'inline-block',
			verticalAlign: 'middle',
			fontSize: pxToEm(10),
			fontWeight: '600',
			lineHeight: '0',
			textDecoration: 'none',
			marginBottom: pxToEm(-2),
			marginRight: pxToEm(6)
		},
		'& .logoimage': {
			extend: imageTypes.logo,
			lineHeight: '0',
			width: pxToEm(80),
			height: pxToEm(12), // 8
			backgroundImage: `url(${url.image.app}/logo-insticator-light-opt.png)`,
			'&:hover': {
				extend: animations.imageHover
			}
		}
	}
};
